// extracted by mini-css-extract-plugin
export var button = "_ed-0";
export var donut = "_ed-1";
export var donutFill = "_ed-3";
export var donutTrack = "_ed-2";